// ForgotPasswordController
app.controller('ForgotPasswordController', ['$scope', '$location', 'WdHttpService', 'sessionService', '$timeout',
    function($scope, $location, WdHttpService, sessionService, $timeout) {

        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
        }

        $scope.submitForgotPasswordForm = function() {
            $scope.submitted = true;

            if ($scope.forgotForm.$valid) {
                $scope.showLoading('#submitForgotPasswordButton');
                if ($scope.username.length == 10 && $scope.username.match('[0-9]{10}')) {
                    $scope.username = '+91' + $scope.username;
                }
                var data = { username: $scope.username };
                WdHttpService._forgot_password(data)
                    .then(function(response) {
                        if (response.status == 200) {
                            sessionService.set("username", JSON.stringify($scope.username));
                            $location.path("/reset-password");
                        };
                    }).catch(error => {
                        $scope.stopLoading('#submitForgotPasswordButton');
                        var msg = error;
                        if (msg == "Please use your temporary password to sign in.") {
                            $scope.errorMessage = false;
                            $scope.linktoTempPass = true;
                        } else {
                            $scope.errorMessage = true;
                            $scope.linktoTempPass = false;
                            $scope.errorMsg = error;
                            $timeout(function() {
                                $scope.errorMessage = false;
                            }, 10 * 1000);
                        }
                    })
            } else {
                return false;
            }
        };
        $scope.resendTempPass = function() {
            if ($scope.username.length == 10 && $scope.username.match('[0-9]{10}')) {
                $scope.username = '+91' + $scope.username;
            }
            var data = { username: $scope.username };
            WdHttpService._resend_activation(data).then(function(response) {
                $location.path("/temp-password-success");
            });
        };

    }
]);